"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFiles = void 0;
var next_api_swr_1 = require("@newfront-insurance/next-api-swr");
var routes_1 = require("../bff/routes");
var apiRoutes = (0, routes_1.createApiRoutes)('/api/files');
function useFiles(objectRefs) {
    // useNextApiSubscription (swr) will attempt 3 retries on error
    return (0, next_api_swr_1.useNextApiSubscription)(apiRoutes.getFiles(objectRefs));
}
exports.useFiles = useFiles;
